import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import jwtDecode, { JwtPayload } from 'jwt-decode';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { StateRedux } from '../store/type-redux';
import Container from './container';
import RequiresPermission from '../pages/RequiresPermission';

interface Props {
  component: ReactElement;
  container?: boolean;
  publico?: boolean;
}

interface T {
  // eslint-disable-next-line camelcase
  resource_access: {
    [x: string]: {
      roles: string[]
    }
  }
}

// const backgroundBody = {
//   add: () => document
//     .querySelector('body')?.classList.add('bg-mtrix-dark'),
//   remove: () => document
//     .querySelector('body')?.classList.remove('bg-mtrix-dark'),
// };

const getListRequiresPermission = (access: any): string[] => {
  const items: string[] = Object.keys(access);

  return items.filter((item) => !access[item]);
};

const MiddlewareRoute = ({
  component, publico, container,
}: Props): ReactElement => {
  const dispatch = useDispatch();
  const { access, realm } = useSelector((state: StateRedux) => state);

  const requestAccess = getListRequiresPermission(access);

  const token = localStorage.getItem('token');
  /**
   * public routes ↓
   */

  if (publico && !token) {
    // backgroundBody.add();
    return component;
  }

  // Sem token
  if ((!token) || (token.length === 1)) {
    dispatch({ type: 'LOGOUT' });
    return <Navigate to="/login" />;
  }

  // Token mal formado
  const decoded: JwtPayload & T = jwtDecode(token);
  if (!decoded.exp) {
    dispatch({ type: 'LOGOUT' });
    return <Navigate to="/login" />;
  }

  // Token expirado
  const tokenExpired = moment.unix(decoded.exp);
  if (moment() > tokenExpired) {
    dispatch({ type: 'LOGOUT' });
    return <Navigate to="/login" />;
  }

  /**
   * private routes ↓
   */

  // backgroundBody.remove();

  if (publico && token) {
    return <Navigate to="/home" />;
  }

  if (token && requestAccess.length) {
    return <RequiresPermission requestAccess={requestAccess} />;
  }

  const { roles } = decoded.resource_access[`${realm.nameRealm}-microservice`];

  return container ? (
    <Container
      admin={roles.includes('admin')}
    >
      {component}
    </Container>
  ) : component;
};

MiddlewareRoute.defaultProps = {
  container: false,
  publico: false,
};

export default MiddlewareRoute;
